import React from 'react';
import TimesIcon from 'adp-react-icons/lib/fa/times-circle';
import CheckCircleIcon from 'adp-react-icons/lib/fa/check-circle';
import classNames from 'classnames';
import { Textbox, Popover, OverlayTrigger, PasswordStrengthIndicator } from 'adp-react-components';

const PasswordRule = (props: {
  valid: boolean;
  children: React.ReactNode;
 }) => (
  <li className={classNames({
    'vdl-password-strength__rule' : true,
    'vdl-password-strength__rule--success' : props.valid,
    'vdl-password-strength__rule--error' : !props.valid
    })
  }>
    <span className="vdl-password-strength__rule-icon">
      {props.valid ? <CheckCircleIcon /> : <TimesIcon />}
    </span>
    { props.children }
  </li>
);

class GlobalPasswordIndicator extends React.Component{
  constructor(props){
    super(props);
    this.state={
      strength: 0,
      strengthText: ''
    }
  }

  minOneLetter = (password: string | undefined) => {
   let validationResult = (password && password.match(/[A-Za-z]/)) ? true : false;
   return validationResult;
  }

  minOneLCLetter = (password: string | undefined) => {
   let validationResult = (password && password.match(/^[a-z]+$/)) ? true : false;
   return validationResult;
  }

  minOneUCLetter = (password: string | undefined) => {
   let validationResult = (password && password.match(/^[A-Z]+$/)) ? true : false;
   return validationResult;
  }

  minOneNumber = (password: string | undefined) => {
    let validationResult = (password && password.length > 0 && password.match(/\d/)) ? true : false;
    return validationResult;
  }

  minEightChars = (password: string | undefined) => {
    let validationResult = (password && password.length >= 8) ? true : false;
    return validationResult;
  }

  goodMinEightMixOfLCUCChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{8,})(((?=.*[A-Z])(?=.*[0-9]))((?=.*[a-z]))).*$/)) ? true : false;
    return validationResult;
  }

  goodMinTwelveLCChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[a-z])(?=.*[0-9]))[a-z0-9]*$/)) ? true : false;
    return validationResult;
  }

  goodMinTwelveUCChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[A-Z])(?=.*[0-9]))[A-Z0-9]*$/)) ? true : false;
    return validationResult;
  }

  goodMinEightLCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{8,})((?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&+=]))[a-z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

  goodMinEightUCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{8,})((?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=]))[A-Z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

  strongMinTwelveLCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&+=]))[a-z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

  strongMinTwelveUCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=]))[A-Z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

  strongMinEightMixOfUCLCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{8,})((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&+=]))[A-Za-z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

  strongMinTwelveLCUCChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]))[A-Za-z0-9]*$/)) ? true : false;
    return validationResult;
  }

  veryStrongMinTwelveLCUCSpecialChars = (password: string | undefined) => {
    let validationResult = (password && password.match(/^(?=.{12,})((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&+=]))[A-Za-z0-9@#$%^&+=]*$/)) ? true : false;
    return validationResult;
  }

 onPasswordChange = (password: string) => {
   let strengthVal = this.state.strength;
   let passwordVal = password;
   let strengthTextVal = this.state.strengthText;

   if (passwordVal && passwordVal.length > 0) {
     //Not valid
     if (this.minOneLetter(passwordVal) || this.minOneNumber(passwordVal) || this.minEightChars(passwordVal)) {
       strengthVal = 0;
       strengthTextVal = 'Not Valid';
     }

     // weak
     if (!(this.minOneLCLetter(passwordVal) && this.minOneUCLetter(passwordVal)) && this.minOneNumber(passwordVal) && this.minEightChars(passwordVal)) {
       strengthVal = 1;
       strengthTextVal = 'Weak';
     }

     // Good
     if (this.goodMinEightMixOfLCUCChars(passwordVal) || this.goodMinTwelveLCChars(passwordVal) || this.goodMinTwelveUCChars(passwordVal) || this.goodMinEightLCSpecialChars(passwordVal) || this.goodMinEightUCSpecialChars(passwordVal)) {
       strengthVal = 2;
       strengthTextVal = 'Good';
     }

     // Strong
     if (this.strongMinTwelveLCSpecialChars(passwordVal) || this.strongMinTwelveUCSpecialChars(passwordVal) || this.strongMinEightMixOfUCLCSpecialChars(passwordVal) || this.strongMinTwelveLCUCChars(passwordVal)) {
       strengthVal = 3;
       strengthTextVal = 'Strong';
     }

     // Very Strong
     if (this.veryStrongMinTwelveLCUCSpecialChars(passwordVal)) {
       strengthVal = 4;
       strengthTextVal = 'Very Strong';
     }
   } else {
     strengthVal = 0;
   }

   this.setState({
     password: password,
     strength: strengthVal,
     strengthText: strengthTextVal
   });

   if(this.props.isPasswordCallBackRequired == "yes"){
      this.props.passwordCallBackFun(password);
   }

 }

render(){

  let passwordVal = this.state.password ? this.state.password : '';
  var passwordPopover = (
        <Popover
          id="password-popover"
          title=""
        >
          <div className="vdl-password-strength__popover-content">
            <PasswordStrengthIndicator strength={this.state.strength} strengthText={this.state.strengthText}>
              <PasswordRule valid={this.minOneLetter(passwordVal)}>
                {this.props.passwordStrengthIndLetterLabel}
              </PasswordRule>
              <PasswordRule valid={this.minOneNumber(passwordVal)}>
                {this.props.passwordStrengthIndNumberLabel}
              </PasswordRule>
              <PasswordRule valid={this.minEightChars(passwordVal)}>
                {this.props.passwordStrengthIndCharsLabel}
              </PasswordRule>
            </PasswordStrengthIndicator>
          </div>
        </Popover>
      );

  return(
    <div>
    <OverlayTrigger
      trigger="focus"
      placement={this.props.position}
      overlay={passwordPopover}
    >
    <Textbox id={this.props.textBoxId} style={this.props.styles} value={this.state.password} type="password" onChange={this.onPasswordChange.bind(this)}>
      </Textbox>
    </OverlayTrigger>
    </div>
  );
}
}

export default GlobalPasswordIndicator;



// WEBPACK FOOTER //
// ./src/components/utils/global-password-indicator.js